import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { CircularProgress } from '@material-ui/core';
import { Grid, Paper } from "@material-ui/core";
import { toast } from 'react-toastify';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';

import RenderComponentBasedOnStep from './RenderComponentBasedOnStep';
import { Font, FontSize } from 'styled-icons/boxicons-regular';
import { fetchUpdateOpportunityPayload, fetchSingleOpportunityPayload } from './utils/payload';
import useStyles from './style';
import WorkFlowModelViewer from './model';
import CreateIcon from '@material-ui/icons/Create';
import CommentViewer from './comments';

const HorizontalLinearStepper = (props) => {
    const { steps, orgId } = props
    const { chartUniqueId, chartData } = props.data
    const { isWorkFlowEnable, workFlowId, isCommentSectionEnable } = chartData
    const [activeStep, setActiveStep] = useState(1);
    const [blockState, setBlockState] = useState({})
    const [selectedStep, setSelectedStep] = useState(steps[0]);
    const [skipped, setSkipped] = useState(new Set())
    const [saveAndNext, setSaveAndNext] = useState(false)
    const [invokeSubmit, setInvokeSubmit] = useState(false)
    const [externalSubmitTrigger, setexternalSubmitTrigger] = useState(false)

    const [globalErrors, setGlobalErrors] = useState([])

    const [stepValidation, setStepValidation] = useState(true)

    const [isEditMode, setIsEditMode] = useState(false)

    const [modalInfo, setModalInfo] = useState({ enable: false });

    const [workflow, setWorkflow] = useState(null)

    const [currentButtonClicked, setCurrentButtonClicked] = useState(null);

    const [defaultOptionsDropdown, setDefaultOptionsDropdown] = useState([]);
    const [firstStepsMembersDropdown, setFirstStepsMembersDropdown] = useState([]);
    const [saveId, setSaveId] = useState(null);

    const nextStep = props.formData?.document?.[chartUniqueId + '_create_Task_next_step'] || {}

    const enableRejectButton = blockState?.actions?.length ? true : false

    const onModelClick = (type, obj, data = {}) => {
        if (type === 'delete') {
            setModalInfo({ enable: true, title: '', type, data: obj, ...data });
        }
        else if (type === 'save') {
            setModalInfo({ enable: true, title: '', type, data: obj, ...data });
        }
        else if (type === 'assignTo') {
            // onAssignToFirstStepMembers();
            getFirstStepMembers()
            setModalInfo({ enable: true, title: '', type, data: obj, ...data });
        }
        else if (type === 'JustSave') {
            setModalInfo({ enable: true, title: '', type, data: obj, ...data });
        }
    };

    console.log('blockState**HorizontalLinearStepper', props, isEditMode)

    const onCloseModel = () => setModalInfo({ enable: false });

    const checkConditions = (conditions, blockState) => {
        console.log('checkConditions', blockState);

        if (!conditions || conditions.length === 0) return true;

        let result = null;

        for (const cond of conditions) {
            const fieldValue = blockState[cond.selectedConditionDataElement];

            if (fieldValue === undefined || fieldValue === null) continue;

            let isMet = false;
            switch (cond.selectedConditionOperator) {
                case "is_equals":
                    isMet = fieldValue === cond.value;
                    break;
                case "is_not_equals":
                    isMet = fieldValue !== cond.value;
                    break;
                case "contains":
                    isMet = Array.isArray(fieldValue) && fieldValue.includes(cond.value);
                    break;
                case "not_contains":
                    isMet = Array.isArray(fieldValue) && !fieldValue.includes(cond.value);
                    break;
                default:
                    isMet = true;
            }

            if (cond.selectedConditionClause === "or") {
                result = result === null ? isMet : result || isMet;
            } else if (cond.selectedConditionClause === "and") {
                result = result === null ? isMet : result && isMet;
            }
        }

        return result === null ? false : result;
    };

    const fetchTasks = (currentTaskId) => {
        if (currentTaskId && workFlowId) {
            let payload = {
                workflowId: workFlowId,
                currentTaskId: currentTaskId,
                appId: props.match.params.appid,
                dataUniqueId: chartUniqueId + '_create_Task_next_step',
                data: {
                    docId: props.match.params.id,
                    dmId: chartData?.selectedDataModel,
                }
            }
            props.getNextTasks(payload)
        }
    }

    const onRejectObligation = () => {
        let payload = {
            dataUniqueId: `${chartUniqueId}_rejected_create_document`,
            obligationId: props.match.params.id,
            dataModelId: chartData?.selectedDataModel,
            appId: props.appId,
            data: {
                "status": "Rejected"
            },
            orgId: props.orgId
        }
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${chartUniqueId}_getsingleobligation`]
        })
        props.rejectedWorkFlowObligations(payload)
    }

    useEffect(() => {
        const updatedData = props.formData?.document?.[`${chartUniqueId}_rejected_create_document`];
        if (updatedData) {
            toast.success('This Document is Rejected')
            props.clearReduxDataOfCurrentComponent({
                key: 'document',
                subKey: [`${chartUniqueId}_rejected_create_document`]
            })
            fetchSingleOpportunity();
        }
    }, [props.formData?.document?.[`${chartUniqueId}_rejected_create_document`]])

    const visibleSteps = steps.filter((step) => checkConditions(step.conditions, blockState));

    console.log('blockState**HorizontalLinearStepper', workflow)

    const classes = useStyles();

    const handleEditModeChange = (editMode) => {
        console.log('handleEditModeChange**prop', editMode)
        setIsEditMode(editMode);
    };

    const checkRoleMatch = () => {
        const memberRoles = props.members?.roles || [];
        const respondentRoles = blockState?.workflow?.respondent?.role || [];

        console.log('checkRoleMatch', memberRoles, checkRoleMatch)

        return memberRoles.some(memberRole =>
            respondentRoles.some(respondentRole =>
                memberRole.name === respondentRole.name
            )
        );
    };

    console.log('checkRoleMatch**1', checkRoleMatch())




    useEffect(() => {
        const hasOpportunityId = props?.match?.params?.id;
        if (hasOpportunityId) {
            fetchSingleOpportunity();
        }
    }, [selectedStep, props.match.params.id])


    useEffect(() => {
        let d = props.formData?.document?.[`${props.data.chartUniqueId}_First_Step_Members`];
        setFirstStepsMembersDropdown(d);
        const formattedWorkflow = d?.map(item => ({
            value: item.name,
            label: item.name,
        }));
        setDefaultOptionsDropdown(formattedWorkflow);
    }, [props.formData?.document?.[`${props.data.chartUniqueId}_First_Step_Members`]]);


    useEffect(() => {
        isWorkFlowEnable && getWorkflow(workFlowId)
        return () => {
            clearCurrentChartReduxStore()
        }
    }, [])

    const getWorkflow = (workflowId) => {
        let payload = {
            id: workflowId,
            dataUniqueId: `${chartUniqueId}_create_workflows`,
            appId: props.match.params.appid,
        }
        props.getWorkflowById(payload)
    }


    useEffect(() => {
        if (props.formData?.document?.[`${chartUniqueId}_create_workflows`]) {
            setWorkflow(props.formData?.document[chartUniqueId + '_create_workflows']?.['diagram']?.['steps'])
        }
    }, [props.formData?.document?.[`${chartUniqueId}_create_workflows`]])

    const fetchSingleOpportunity = () => {
        let payload = fetchSingleOpportunityPayload(props.match.params.appid, orgId, selectedStep, props.match.params.id, chartUniqueId)
        props.getSingleOpportunity(payload)
    }

    // // Below UseEffect is used for updating the State variable after getting the current Opportunity Data
    useEffect(() => {
        if (props.formData?.document[chartUniqueId + '_getsingleopportunity']) {
            let obj = props.formData?.document[chartUniqueId + '_getsingleopportunity'] || {}

            if (obj['workflow']) {
                fetchTasks(obj['workflow']?.id)
            }
            if (obj['workflow']?.['label'] === 'Identification') {
                props.history.push({
                    pathname: `/${props?.match?.params?.appid}/page/${chartData.MoveToTracker}/${props.match.params.id}`
                });
            }
            // else if (obj['workflow']?.['label'] !== 'Identification' && obj['identification']) {

            // }
            else if (obj['workflow'] && obj['identification'] && obj['workflow']?.['label'] !== 'Identification') {
                props.history.push({
                    pathname: `/${props?.match?.params?.appid}/page/${chartData.MoveToTracker}/${props.match.params.id}`
                });
            }
            // setJson(obj);
            setBlockState(obj)
        }
    }, [props.formData?.document[chartUniqueId + '_getsingleopportunity']])

    const onAssignToFirstStepMembers = () => {
        if (isWorkFlowEnable && props.match.params.id) {
            onCloseModel()
            onModelClick('assignTo', {})
        }
        else if (isWorkFlowEnable && !props.match.params.id) {
            onCloseModel()
            onModelClick('assignTo', {})
        }
    }

    const clearCurrentChartReduxStore = () => {
        let subKeys = [
            props.data.chartUniqueId + '_getsingleopportunity',
            props.data.chartUniqueId + '_updateopportunity',
            props.data.chartUniqueId + '_save',
            props.data.chartUniqueId + '_upload_attachments_opp',
            props.data.chartUniqueId + '_Create_Task',
            props.data.chartUniqueId + '_First_Step_Members',
            props.data.chartUniqueId + '_Current_Steps_Members',
            props.data.chartUniqueId + '_Current_Step_Assigning_Upated',
            props.data.chartUniqueId + '_create_workflows',
            props.data.chartUniqueId + '_Create_Task_ID',
            props.data.chartUniqueId + '_execute_create_Workflow',
            props.data.chartUniqueId + '_create_executeWorkflow_reject',
            props.data.chartUniqueId + '_Add_Comment_Create',
            props.data.chartUniqueId + '_documentsfromIds_' + blockState?.dataModel,
        ]

        if (steps && steps.length > 0) {
            steps.forEach(step => {
                if (step.blocks && step.blocks.length > 0) {
                    step.blocks.forEach(block => {
                        if (block.type === 'attachmentDocument' && block.dataModel) {
                            subKeys.push(props.data.chartUniqueId + '_documentsfromIds_' + block.dataModel);
                        }
                    });
                }
            });
        }
        props.clearReduxDataOfCurrentComponent({
            key: "document",
            subKey: subKeys
        })
    }

    const getFirstStepMembers = () => {
        let payload = {
            dataUniqueId: `${props.data.chartUniqueId}_First_Step_Members`,
            payload: {
                "workFlowId": workFlowId
            },
            appId: props.match.params.appid,
        }
        props.getFirstStepMembers(payload)
    }



    const uploadLocalFiles = (opportunityId) => {

        console.log('selectedStep*::', selectedStep)
        const localFiles = blockState[`uploadedFiles`] || [];

        if (localFiles.length === 0) {
            return;
        }

        // Upload each local file
        localFiles.forEach((fileData, index) => {
            const formData = new FormData();
            formData.append('file', fileData.file);

            const payload = {
                formData,
                appId: props.match.params.appid,
                dataModelId: fileData.dataModelId,
                subDataModelId: fileData.subDataModelId,
                opportunityId: opportunityId,
                dataUniqueId: `${chartUniqueId}_upload_attachments_opp`,
            };

            props.uploadAttachmentOpportunity(payload);
        });
        // Clear local files from state after successful upload

    };



    useEffect(() => {
        let res = props.formData.document[chartUniqueId + '_upload_attachments_opp'];
        if (res) {
            if (isWorkFlowEnable) {
                if (!props.match?.params?.id) {
                    onModelClick('save', {});
                }
            }
            else {
                onModelClick('JustSave', {});
            }
        }
    }, [props.formData?.document?.[chartUniqueId + '_upload_attachments_opp']])

    useEffect(() => {
        let res = props.formData.document[chartUniqueId + '_save'];
        if (res) {
            setSaveId(res.data.result.insertedId);
            if (blockState['uploadedFiles'] && blockState['uploadedFiles'].length > 0) {
                if (res.data.result && res.data.result.insertedId) {
                    uploadLocalFiles(res.data.result.insertedId);
                }
            } else {
                if (isWorkFlowEnable) {
                    onModelClick('save', { id: res.data.result.insertedId });
                }
                else {
                    onModelClick('JustSave', { id: res.data.result.insertedId });
                }
            }

        }
    }, [props.formData?.document?.[chartUniqueId + '_save']])

    useEffect(() => {
        if (props.formData?.document[chartUniqueId + '_updateopportunity']?._id) {
            let obj = props.formData?.document[chartUniqueId + '_updateopportunity'] || {}
            setBlockState(obj)
            toast.success('Document Updated Successfully')
            if (activeStep < visibleSteps.length) {
                props.clearReduxDataOfCurrentComponent({
                    key: 'document',
                    subKey: [`${chartUniqueId}_updateopportunity`]
                })
                setIsEditMode(false)
            }
            else {
                props.clearReduxDataOfCurrentComponent({
                    key: 'document',
                    subKey: [`${chartUniqueId}_updateopportunity`]
                })
                setIsEditMode(false)
                // handleBackBtnClick()
            }
        } else {
            console.log("Error in Update Identify Step");
        }
    }, [props.formData?.document[chartUniqueId + '_updateopportunity']])

    const updateStepValidation = () => {
        setStepValidation(!stepValidation);
    };

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const saveHandler = () => {
        if (saveAndNext) {
            setInvokeSubmit(true)
        } else {
            handleNext()
        }
    }

    const handleCustomeSubmitTrigger = () => {
        setexternalSubmitTrigger(true)
    }

    const resetSubmitTrigger = () => {
        setexternalSubmitTrigger(false)
    }

    const handleCustomeBackTrigger = () => {
        props.history.push({
            pathname: `/${props?.match?.params?.appid}/page/${chartData.listPages}`
        });
    }

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            throw new Error("You can't skip a step that isn't optional.");
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const handleReset = () => {
        setActiveStep(0);
        setSelectedStep(steps[0])
    };
    const handleBackTo = (stepNumber) => {
        setActiveStep(stepNumber);
        setSelectedStep(steps[stepNumber - 1]);
    };

    const validateCurrentStep = () => {
        if (!selectedStep || !selectedStep.blocks) return true;

        for (const block of selectedStep.blocks) {
            if (!checkConditions(block.conditions, blockState)) continue;

            if (block.validation && block.validation.enable) {
                if (!validateBlockByConfig(block, blockState)) {
                    return false;
                }
            }
        }

        return true;
    };

    const validateBlockByConfig = (block, blockState) => {
        const { validation } = block;

        if (!validation.enable) return true;

        if (validation.fields) {
            if (Array.isArray(validation.fields)) {
                for (const field of validation.fields) {
                    const fieldValue = blockState[field];
                    if (!fieldValue || fieldValue === null || fieldValue === '') {
                        return false;
                    }
                }
            } else if (validation.fields === "required") {
                if (block.type === "summaryItems" && block.config?.dataElements) {
                    for (const dataElement of block.config.dataElements) {
                        if (dataElement.required && (!blockState[dataElement.value] || blockState[dataElement.value] === null || blockState[dataElement.value] === '')) {
                            return false;
                        }
                    }
                }
            }
        }

        return true;
    };

    const handleNext = () => {
        setIsEditMode(false)
        if (!validateCurrentStep()) {
            toast.error('Please fill all required fields before proceeding to the next step');
            console.log('Please fill all required fields before proceeding to the next step');
            return;
        }
        const currentIndex = visibleSteps.findIndex((s) => s.name === selectedStep.name);

        console.log('handleNext***&&', currentIndex, visibleSteps, selectedStep)
        if (currentIndex === -1) return;

        const nextIndex = currentIndex + 1;
        if (nextIndex < visibleSteps.length) {
            const nextStep = visibleSteps[nextIndex];
            setActiveStep(nextIndex + 1);
            setSelectedStep(nextStep);
        }
    };

    const handleBack = () => {
        setIsEditMode(false)
        const currentIndex = visibleSteps.findIndex((s) => s.name === selectedStep.name);
        if (currentIndex <= 0) return;

        const prevStep = visibleSteps[currentIndex - 1];
        setActiveStep(currentIndex);
        setSelectedStep(prevStep);
    };

    const handleSaveAndNext = () => {
        let data = Object.assign({}, blockState);
        let formData = {
            appid: props.match.params.appid,
            dataModelId: chartData?.selectedDataModel,
            payload: data
        }

        if (props?.match?.params?.id) {
            formData['dataUniqueId'] = chartUniqueId + '_updateopportunity'
            let blockStateObject = JSON.parse(JSON.stringify(blockState))
            if (blockStateObject['_id']) {
                blockStateObject['id'] = blockStateObject['_id'];
                delete blockStateObject._id;
            }
            let payloadData = fetchUpdateOpportunityPayload(props.match.params.appid, selectedStep, props.match.params.id, chartUniqueId, blockStateObject)
            props.updateOpportunity(payloadData);
        }
    }

    const handleSave = () => {
        let formData = {}
        if (props?.match?.params?.id) {
            formData['dataUniqueId'] = chartUniqueId + '_updateopportunity'
            let blockStateObject = JSON.parse(JSON.stringify(blockState))
            if (blockStateObject['_id']) {
                blockStateObject['id'] = blockStateObject['_id'];
                delete blockStateObject._id;
            }
            let payloadData = fetchUpdateOpportunityPayload(props.match.params.appid, selectedStep, props.match.params.id, chartUniqueId, blockStateObject)
            props.updateOpportunity(payloadData);
        }
        else {
            let data = Object.assign({}, blockState);
            if (data['uploadedFiles']) {
                delete data.uploadedFiles;
            }
            formData = {
                appid: props.match.params.appid,
                dataModelId: chartData?.selectedDataModel,
                payload: data
            }

            formData['dataUniqueId'] = chartUniqueId + '_save'
            props.createObligationsDocument(formData)
        }
    }

    const handleBackBtnClick = () => {
        const lastPage = chartData.listPage;
        if (lastPage) {
            props.history.push({ pathname: `/${props.match.params.appid}/page/${lastPage}` });
        }
    }

    const chatRedirect = () => {
        props.history.push({
            pathname: `/${props?.match?.params?.appid}/page/${chartData.listPage}`
        });
    };

    const onNoLater = () => {
        setModalInfo({ enable: false });
        handleBackBtnClick()
    }

    const onJustSaveClick = () => {
        setModalInfo({ enable: false });
        handleBackBtnClick()
    }

    useEffect(() => {
        if (props.formData?.document?.[`${chartUniqueId}_Create_Task`]) {
            onCloseModel();
            const message = `The document has been successfully ${workflow[0]?.label} `;
            props.clearReduxDataOfCurrentComponent({
                key: 'document',
                subKey: [`${props.data.chartUniqueId}_Create_Task`],
            });
            showConfirmationDialogORToast('success', message);
        }
    }, [props.formData?.document?.[`${chartUniqueId}_Create_Task`]]);

    useEffect(() => {
        if (props.formData?.document?.[`${chartUniqueId}_Create_Task_ID`]) {
            onCloseModel();
            const message = `The document has been successfully ${workflow[0]?.label} `;
            showConfirmationDialogORToast('success', message, { nextRespondent: true });
            props.clearReduxDataOfCurrentComponent({
                key: 'document',
                subKey: [`${props.data.chartUniqueId}_Create_Task_ID`],
            });
        }
    }, [props.formData?.document?.[`${chartUniqueId}_Create_Task_ID`]]);

    const showConfirmationDialogORToast = (type, message, options = {}) => {
        if (['success', 'rejected'].includes(type)) {
            setModalInfo({ enable: true, title: type, type, message, ...options });
        }
    };

    const onSucessClick = () => {
        setModalInfo({ enable: false });
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${props.data.chartUniqueId}_getsingleopportunity`],
        });
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${props.data.chartUniqueId}_Create_Task`],
        });
        props.history.push({
            pathname: `/${props?.match?.params?.appid}/page/${props?.match?.params?.page}/${saveId}`
        });
        // handleBackBtnClick()
    };
    const onSucessNextRespondentClick = () => {
        setModalInfo({ enable: false });
        fetchSingleOpportunity();
    };
    const onRejectedNextRespondentClick = () => {
        setModalInfo({ enable: false });
        fetchSingleOpportunity();
    };

    const onRejectedModel = () => {
        setModalInfo({ enable: false });
        fetchSingleOpportunity();
    };

    const onSaveMembersToFirstStep = (v, data) => {
        if (props.match.params.id) {
            let payload = {
                dataUniqueId: `${chartUniqueId}_Create_Task_ID`,
                obligationId: props.match.params.id,
                dataModelId: chartData?.selectedDataModel,
                appId: props.match.params.appid,
                data: {
                    workFlowId: workFlowId,
                    isCreateEnable: true,
                },
                orgId: props.orgId
            }
            payload["data"]['member'] = (() => {
                const found = firstStepsMembersDropdown.find((item) => item.name === v.value || item.name === v.value);
                return found;
            })();
            props.acceptWorkFlowObligations(payload)
        }
        else if (!props.match.params.id) {
            let payload = {
                dataUniqueId: `${chartUniqueId}_Create_Task`,
                obligationId: saveId,
                dataModelId: chartData?.selectedDataModel,
                appId: props.match.params.appid,
                data: {
                    workFlowId: workFlowId,
                    isCreateEnable: true,
                },
                orgId: props.orgId
            }
            payload["data"]['member'] = (() => {
                const found = firstStepsMembersDropdown.find((item) => item.name === v.value || item.name === v.value);
                return found;
            })();

            props.acceptWorkFlowObligations(payload)
        }

    }



    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const toCamelCase = (str) => str?.toLowerCase()?.replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr?.toUpperCase());

    const currentStepAsignedToMe = () => {
        changeAssignee({
            selfAssign: false,
            documentId: props.match.params.id,
            member: { id: props.members._id, name: props.members.name },
        });
    }

    const changeAssignee = (payload) => {
        let finalpayload = {
            ...payload,
            appid: props.match.params.appid,
            dataModelId: props.data.chartData.selectedDataModel,
            dataUniqueId: props.data?.chartUniqueId + '_Current_Step_Assigning_Upated',
        };
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${props.data.chartUniqueId}_getsingleopportunity`],
        });
        props.changeAssigneeRequest(finalpayload);
    };

    useEffect(() => {
        if (props.formData?.document?.[`${props.data?.chartUniqueId}_Current_Step_Assigning_Upated`]) {
            toast.success(props.formData?.document?.[`${props.data?.chartUniqueId}_Current_Step_Assigning_Upated`]?.message);
            props.clearReduxDataOfCurrentComponent({
                key: 'document',
                subKey: [`${props.data.chartUniqueId}_Current_Step_Assigning_Upated`],
            });
            onCloseModel();
            fetchSingleOpportunity();
        }
    }, [props.formData?.document?.[`${props.data?.chartUniqueId}_Current_Step_Assigning_Upated`]]);

    const currentStepMembersForobligation = (obj) => {
        let payload = {
            dataUniqueId: `${props.data.chartUniqueId}_Current_Steps_Members`,
            currentStepsId: blockState['workflow'].id,
            payload: { workFlowId: props.data.chartData.workFlowId },
            appId: props.match.params.appid,
        };
        props.currentStepMembersForobligation(payload);
    };

    useEffect(() => {
        if (props.formData?.document?.[`${props.data.chartUniqueId}_Current_Steps_Members`]) {
            let d = props.formData?.document?.[`${props.data.chartUniqueId}_Current_Steps_Members`];

            setFirstStepsMembersDropdown(d);

            const formattedWorkflow = d?.filter((item) => item.name !== blockState?.[toCamelCase(blockState?.status)]?.name).map((item) => ({ value: item.name, label: item.name })) || [];

            setDefaultOptionsDropdown(formattedWorkflow);
        }
    }, [
        props.formData?.document?.[`${props.data.chartUniqueId}_Current_Steps_Members`],
    ]);


    const onModelClickForCurrentStepMembers = (type, obj) => {
        if (type === 'assignTo') {
            setModalInfo({ enable: true, title: '', type, data: obj, parent: true });
            currentStepMembersForobligation(obj)
        }
    };

    const onAssignToParent = (v) => {
        changeAssignee({
            selfAssign: false,
            documentId: props.match.params.id,
            member: (() => {
                const found = firstStepsMembersDropdown.find((item) => item.name === v.value || item.name === v.value);
                return found;
            })(),
        });
    };

    const onModelClickForNextRespondent = (type, obj) => {
        if (type === 'assignTo') {
            setModalInfo({ enable: true, title: '', type, data: obj, nextRespondent: true });
            fetchNextRespondents(obj);
        }
    };

    const fetchNextRespondents = (obj) => {
        let payload = {
            workflowId: props.data.chartData.workFlowId,
            currentTaskId: blockState?.workflow?.id,
            appId: props.match.params.appid,
            orgId: props.user?.orgId,
            dataUniqueId: props.data.chartUniqueId + '_Obligations_Next_Respondent',
            data: {
                docId: props.match.params.id,
                dmId: props.data.chartData.selectedDataModel,
                nextTaskId: obj.id,
            },
        };
        setCurrentButtonClicked(obj);
        props.getNextRespondent(payload);
    };

    const onAssignTo = (v) => {
        let value = [v];
        let payload = {
            isMulti: false,
            workflowId: props.data.chartData.workFlowId,
            currentTaskId: blockState?.workflow?.id,
            appId: props.match.params.appid,
            orgId: props.user?.orgId,
            dataUniqueId: props.data.chartUniqueId + '_execute_create_Workflow',
            data: {
                docId: props.match.params.id,
                dmId: props.data.chartData.selectedDataModel,
                nextTaskId: currentButtonClicked.id,
            },
        };
        if (value[0] !== null && value?.length && value[0]?.value) {
            payload.data['nextRespondent'] = { _id: value[0].value, name: value[0].label };
        }
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${props.data.chartUniqueId}_getsingleobligation`],
        });
        props.executeWorkFlow(payload);
    };

    useEffect(() => {
        if (props.formData?.document[props.data.chartUniqueId + '_execute_create_Workflow']) {
            setModalInfo({ enable: false });
            const executeWorkFlow = props.formData?.document[props.data.chartUniqueId + '_execute_create_Workflow'];
            const message = executeWorkFlow?.message || 'Workflow executed successfully';
            props.clearReduxDataOfCurrentComponent({
                key: 'document',
                subKey: [`${props.data.chartUniqueId}_getsingleopportunity`],
            });
            props.clearReduxDataOfCurrentComponent({
                key: 'document',
                subKey: [`${props.data.chartUniqueId}_execute_create_Workflow`],
            });
            showConfirmationDialogORToast('success', message, { nextRespondent: true });
        }
    }, [props.formData?.document[props.data.chartUniqueId + '_execute_create_Workflow']]);


    useEffect(() => {
        if (props.formData?.document?.[`${props.data.chartUniqueId}_Obligations_Next_Respondent`]) {
            let d = props.formData?.document?.[`${props.data.chartUniqueId}_Obligations_Next_Respondent`];

            setFirstStepsMembersDropdown(d);

            const formattedData = d?.filter((item) => item.id || item._id).map((item) => ({
                value: item.id || item._id,
                label: item.name
            })) || [];

            setDefaultOptionsDropdown(formattedData);
        }
    }, [
        props.formData?.document?.[`${props.data.chartUniqueId}_Obligations_Next_Respondent`],
    ]);

    useEffect(() => {
        if (props.formData?.document?.[props.data.chartUniqueId + '_create_executeWorkflow_reject']) {
            const rejectWorkFlow = props.formData?.document[props.data.chartUniqueId + '_create_executeWorkflow_reject'];
            const message = rejectWorkFlow?.message || 'Workflow executed successfully';
            showConfirmationDialogORToast('rejected', message, { nextRespondent: true });
            props.clearReduxDataOfCurrentComponent({
                key: 'document',
                subKey: [`${props.data.chartUniqueId}_create_executeWorkflow_reject`],
            });
        }
    }, [props.formData?.document?.[props.data.chartUniqueId + '_create_executeWorkflow_reject']]);


    const handleReject = () => {
        let payload = {
            workflowId: props.data.chartData.workFlowId,
            currentTaskId: blockState?.workflow?.id,
            appId: props.match.params.appid,
            dataUniqueId: props.data.chartUniqueId + '_create_executeWorkflow_reject',
            data: {
                docId: props.match.params.id,
                dmId: props.data.chartData.selectedDataModel,
            },
        };
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${props.data.chartUniqueId}_getsingleobligation`],
        });
        props.executeWorkFlowReject(payload);
    };




    return (
        <div className={`${classes.container} myScrollContainer`}>
            {
                (props.formData?.[chartUniqueId + '_getsingleopportunity_loading'] || props.formData?.[chartUniqueId + '_save_loading'] || props.formData?.[chartUniqueId + '_updateopportunity_loading'] || props.formData?.[chartUniqueId + '_rejected_create_document_loading'] || props.formData?.[chartUniqueId + '_upload_attachments_opp_loading']) ? props.loader :
                    (
                        <React.Fragment>
                            <div className={classes.topBar}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, boxSizing: 'border-box' }}>
                                    <div className={classes.backIconBox} onClick={() => { chatRedirect() }}>
                                        <img src={'/media/createStepper/backIcon.svg'} className={classes.backIconImg} />
                                    </div>
                                    <Typography className={classes.headerTitle}>
                                        {props?.match?.params?.id ? 'View Opportunity' : 'Create Opportunity'}
                                    </Typography>
                                </div>
                                {
                                    props.match.params.id && !props.formData?.[`${props.data.chartUniqueId}_getsingleopportunity_loading`] && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 32, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                            {
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                                    <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                        Status
                                                    </Typography>
                                                    <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                        :
                                                    </Typography>
                                                    <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                                        {blockState?.status}
                                                    </Typography>
                                                </div>
                                            }
                                            {
                                                !blockState['workflow'] && blockState['createdByName'] && blockState['status'] !== 'Rejected' && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                            Created By
                                                        </Typography>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                            :
                                                        </Typography>
                                                        <Avatar style={{
                                                            height: 24,
                                                            width: 24,
                                                            fontSize: '11px',
                                                            fontStyle: 'normal',
                                                            fontWeight: 500,
                                                            lineHeight: 'normal',
                                                            backgroundColor: '#5398E6',
                                                            color: 'rgba(255, 255, 255, 1)',
                                                        }}>
                                                            {getInitials(blockState['createdByName'])}
                                                        </Avatar>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                                            {blockState['createdByName']}
                                                        </Typography>
                                                    </div>
                                                )
                                            }

                                            {
                                                !blockState['workflow'] && blockState['rejectedBy']?.name && blockState['status'] === 'Rejected' && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                            Rejected By
                                                        </Typography>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                            :
                                                        </Typography>
                                                        <Avatar style={{
                                                            height: 24,
                                                            width: 24,
                                                            fontSize: '11px',
                                                            fontStyle: 'normal',
                                                            fontWeight: 500,
                                                            lineHeight: 'normal',
                                                            backgroundColor: '#5398E6',
                                                            color: 'rgba(255, 255, 255, 1)',
                                                        }}>
                                                            {getInitials(blockState['rejectedBy']?.name)}
                                                        </Avatar>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                                            {blockState['rejectedBy']?.name}
                                                        </Typography>
                                                    </div>
                                                )
                                            }


                                            {
                                                blockState['workflow'] &&
                                                blockState['workflow']?.currentRespondent &&
                                                blockState['workflow']?.initDate && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                            {blockState["status"] === "Rejected" ? "Rejected By" : "Action owner"}
                                                        </Typography>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                                            :
                                                        </Typography>
                                                        <Avatar style={{
                                                            height: 24,
                                                            width: 24,
                                                            fontSize: '11px',
                                                            fontStyle: 'normal',
                                                            fontWeight: 500,
                                                            lineHeight: 'normal',
                                                            backgroundColor: '#5398E6',
                                                            color: 'rgba(255, 255, 255, 1)',
                                                        }}>
                                                            {blockState["status"] === "Rejected" && blockState["rejectedBy"] ? getInitials(blockState["rejectedBy"]?.name) : getInitials(blockState[toCamelCase(blockState?.status)]?.name)}
                                                        </Avatar>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                                            {blockState["status"] === "Rejected" && blockState["rejectedBy"] ? blockState["rejectedBy"]?.name : blockState[toCamelCase(blockState?.status)]?.name}
                                                        </Typography>
                                                        {
                                                            blockState[toCamelCase(blockState?.status)]?.name === props?.members?.name && blockState["status"] !== "Rejected" && (<div
                                                                style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', cursor: 'pointer' }}
                                                                onClick={() => onModelClickForCurrentStepMembers('assignTo', {})}
                                                            >
                                                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(19, 126, 249, 1)' }}>Edit</Typography>
                                                                <CreateIcon style={{ height: 14, width: 14, color: 'rgba(19, 126, 249, 1)' }} />
                                                            </div>)
                                                        }

                                                        {
                                                            checkRoleMatch() && blockState[toCamelCase(blockState?.status)]?.name !== props?.members?.name && blockState["status"] !== "Rejected" && (
                                                                <Tooltip title="Self Assign" arrow>
                                                                    <div
                                                                        style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', cursor: 'pointer' }}
                                                                        onClick={() => currentStepAsignedToMe()}
                                                                    >
                                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(19, 126, 249, 1)' }}>
                                                                            Self Assign
                                                                            <img
                                                                                src={'/media/svg/selfAssign.svg'}
                                                                                alt="Self Assign"
                                                                                width="14"

                                                                                height="14"
                                                                                style={{ verticalAlign: 'text-bottom' }}
                                                                            />
                                                                        </Typography>
                                                                    </div>
                                                                </Tooltip>
                                                            )
                                                        }

                                                    </div>
                                                )
                                            }

                                            {
                                                !blockState['workflow'] && blockState['createdByName'] && blockState['createdDate'] && blockState['status'] !== 'Rejected' && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>Created Date</Typography>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>:</Typography>
                                                        <div style={{ display: 'flex', alignItems: 'center', boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', gap: 8 }}>
                                                            <img
                                                                src={'/media/svg/calendarObligations.svg'}
                                                                alt="calendar Obligations"
                                                                style={{ height: 20, width: 20 }}
                                                            />
                                                            <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                                                {new Date(blockState?.createdDate).toISOString().split('T')[0]}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                !blockState['workflow'] && blockState['rejectedBy'] && blockState['rejectedDate'] && blockState['status'] === 'Rejected' && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>Rejected Date</Typography>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>:</Typography>
                                                        <div style={{ display: 'flex', alignItems: 'center', boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', gap: 8 }}>
                                                            <img
                                                                src={'/media/svg/calendarObligations.svg'}
                                                                alt="calendar Obligations"
                                                                style={{ height: 20, width: 20 }}
                                                            />
                                                            <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                                                {new Date(blockState?.rejectedDate).toISOString().split('T')[0]}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                blockState['workflow'] &&
                                                blockState['workflow']?.currentRespondent &&
                                                blockState['workflow']?.initDate && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>{blockState["status"] === "Rejected" ? "Rejected Date" : "Action Date"}</Typography>
                                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>:</Typography>
                                                        <div style={{ display: 'flex', alignItems: 'center', boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', gap: 8 }}>
                                                            <img
                                                                src={'/media/svg/calendarObligations.svg'}
                                                                alt="calendar Obligations"
                                                                style={{ height: 20, width: 20 }}
                                                            />
                                                            <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                                                {blockState["status"] === "Rejected" ? new Date(blockState?.rejectedDate).toISOString().split('T')[0] : new Date(blockState?.workflow?.initDate).toISOString().split('T')[0]}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                )
                                            }



                                        </div>
                                    )
                                }
                                {/* {
                    blockState['workflow'] &&
                    blockState['workflow']?.currentRespondent &&
                    blockState['workflow']?.initDate && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 32, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                    Status
                                </Typography>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                    :
                                </Typography>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                    {blockState?.status}
                                </Typography>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                    {blockState["status"] === "Rejected" ? "Rejected By" : "Action owner"}
                                </Typography>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>
                                    :
                                </Typography>
                                <Avatar style={{
                                    height: 24,
                                    width: 24,
                                    fontSize: '11px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    backgroundColor: '#5398E6',
                                    color: 'rgba(255, 255, 255, 1)',
                                }}>
                                    {blockState["status"] === "Rejected" && blockState["rejectedBy"] ? getInitials(blockState["rejectedBy"]?.name) : getInitials(blockState[toCamelCase(blockState?.status)]?.name)}
                                </Avatar>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                    {blockState["status"] === "Rejected" && blockState["rejectedBy"] ? blockState["rejectedBy"]?.name : blockState[toCamelCase(blockState?.status)]?.name}
                                </Typography>
                                {
                                    blockState[toCamelCase(blockState?.status)]?.name === props?.members?.name && blockState["status"] !== "Rejected" && (<div
                                        style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', cursor: 'pointer' }}
                                        onClick={() => onModelClickForCurrentStepMembers('assignTo', {})}
                                    >
                                        <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(19, 126, 249, 1)' }}>Edit</Typography>
                                        <CreateIcon style={{ height: 14, width: 14, color: 'rgba(19, 126, 249, 1)' }} />
                                    </div>)
                                }

                                {
                                    checkRoleMatch() && blockState[toCamelCase(blockState?.status)]?.name !== props?.members?.name && blockState["status"] !== "Rejected" && (
                                        <Tooltip title="Self Assign" arrow>
                                            <div
                                                style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', cursor: 'pointer' }}
                                                onClick={() => currentStepAsignedToMe()}
                                            >
                                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(19, 126, 249, 1)' }}>
                                                    Self Assign
                                                    <img
                                                        src={'/media/svg/selfAssign.svg'}
                                                        alt="Self Assign"
                                                        width="14"

                                                        height="14"
                                                        style={{ verticalAlign: 'text-bottom' }}
                                                    />
                                                </Typography>
                                            </div>
                                        </Tooltip>
                                    )
                                }

                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, boxSizing: 'border-box', height: '32px', boxSizing: 'border-box' }}>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>{blockState["status"] === "Rejected" ? "Rejected Date" : "Action Date"}</Typography>
                                <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(97, 97, 97, 1)' }}>:</Typography>
                                <div style={{ display: 'flex', alignItems: 'center', boxSizing: 'border-box', height: '32px', boxSizing: 'border-box', gap: 8 }}>
                                    <img
                                        src={'/media/svg/calendarObligations.svg'}
                                        alt="calendar Obligations"
                                        style={{ height: 20, width: 20 }}
                                    />
                                    <Typography style={{ fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(33, 33, 33, 1)' }}>
                                        {blockState["status"] === "Rejected" ? new Date(blockState?.rejectedDate).toISOString().split('T')[0] : new Date(blockState?.workflow?.initDate).toISOString().split('T')[0]}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    )
                } */}
                            </div>
                            {
                                (props.formData?.[chartUniqueId + '_getsingleopportunity_loading'] || props.formData?.[chartUniqueId + '_save_loading'] || props.formData?.[chartUniqueId + '_updateopportunity_loading'] || props.formData?.[chartUniqueId + '_rejected_create_document_loading'] || props.formData?.[chartUniqueId + '_upload_attachments_opp_loading'])
                                    ? props.loader
                                    : (
                                        <React.Fragment>
                                            <div className={`${classes.outerCard} myScrollContainer`}>
                                                <div className={classes.stepHeader} style={{ scrollbarWidth: 'none !important' }}>
                                                    {
                                                        steps.length > 0 &&
                                                        steps.filter((step) => checkConditions(step.conditions, blockState)).map((step, index) => {
                                                            const stepNumber = index + 1;
                                                            const isStepAllowed = checkConditions(step.conditions, blockState);
                                                            if (!isStepAllowed) return null;

                                                            if (stepNumber === activeStep) {
                                                                return (
                                                                    <div key={index} className={classes.stepCardActive}>
                                                                        <div className={classes.stepNumberActive}>
                                                                            <Typography className={classes.stepNumberText}>
                                                                                {stepNumber}
                                                                            </Typography>
                                                                        </div>
                                                                        <div className={classes.stepTextWrap}>
                                                                            <Typography className={classes.stepLabelActive}>
                                                                                {step.label}
                                                                            </Typography>
                                                                            <Typography className={classes.stepSupportingActive}>
                                                                                {step.suportingText}
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            if (stepNumber > activeStep) {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className={classes.stepCardUpcoming}
                                                                        onClick={() => handleNext()}
                                                                    >
                                                                        <div className={classes.stepNumberUpcoming}>
                                                                            <Typography className={classes.stepNumberText}>
                                                                                {stepNumber}
                                                                            </Typography>
                                                                        </div>
                                                                        <div className={classes.stepTextWrap}>
                                                                            <Typography className={classes.stepLabelUpcoming}>
                                                                                {step.label}
                                                                            </Typography>
                                                                            <Typography className={classes.stepSupportingUpcoming}>
                                                                                {step.suportingText}
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className={classes.stepCardCompleted}
                                                                    onClick={() => handleBack()}
                                                                >
                                                                    <div className={classes.stepTick}>
                                                                        <img
                                                                            src={"/media/createStepper/cardTick.svg"}
                                                                            className={classes.stepTickIcon}
                                                                        />
                                                                    </div>
                                                                    <div className={classes.stepTextWrap}>
                                                                        <Typography className={classes.stepLabelCompleted}>
                                                                            {step.label}
                                                                        </Typography>
                                                                        <Typography className={classes.stepSupportingCompleted}>
                                                                            {step.suportingText}
                                                                        </Typography>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                                {activeStep > steps.length && steps.length > 1 ? (
                                                    <React.Fragment>
                                                        <Typography className={classes.finishedText}>
                                                            All steps completed - you&apos;re finished
                                                        </Typography>
                                                    </React.Fragment>
                                                ) : (
                                                    <div className={`myScrollContainer ${classes.contentScroll}`}>
                                                        {
                                                            <RenderComponentBasedOnStep
                                                                selectedStep={selectedStep}
                                                                setBlockState={setBlockState}
                                                                blockState={blockState}
                                                                updateStepValidation={updateStepValidation}
                                                                isEditMode={isEditMode}
                                                                onEditModeChange={handleEditModeChange}
                                                                onModelClick={onModelClick}
                                                                fetchTasks={fetchTasks}
                                                                {...props}
                                                            />
                                                        }
                                                    </div>
                                                )}
                                            </div>

                                            {
                                                props.formData?.[chartUniqueId + '_Add_Comment_Create_loading'] ? props.loader : (
                                                    isCommentSectionEnable && blockState?.workflow
                                                        ? (
                                                            <CommentViewer
                                                                {...props}
                                                                blockState={blockState}
                                                                fetchSingleObligation={fetchSingleOpportunity}
                                                            />
                                                        )
                                                        : null
                                                )
                                            }

                                            {/* // {isCommentSectionEnable && blockState['workflow'] && (
                                //     <CommentViewer {...props} blockState={blockState} fetchSingleObligation={fetchSingleOpportunity} />
                                // )} */}

                                            <div className={classes.footer}>
                                                {activeStep > 1 && (
                                                    <Button
                                                        variant="contained"
                                                        className={classes.prevBtn}
                                                        onClick={() => { handleBack() }}
                                                    >
                                                        Previous
                                                    </Button>
                                                )}

                                                {activeStep < visibleSteps.length ? (
                                                    <Button
                                                        variant="contained"
                                                        className={isEditMode ? classes.primaryBtnUpdate : classes.primaryBtn}
                                                        onClick={() => {
                                                            if (isEditMode) {
                                                                handleSaveAndNext()
                                                            }
                                                            else {
                                                                handleNext()
                                                            }
                                                        }}
                                                    >
                                                        {isEditMode ? 'Update' : 'Next'}
                                                    </Button>

                                                ) : (
                                                    <div style={{ display: 'flex', gap: '10px' }}>
                                                        {
                                                            !blockState["workflow"] && !props?.match?.params?.id && <Button
                                                                variant="contained"
                                                                className={classes.primaryBtn}
                                                                onClick={() => { handleSave() }}
                                                            >
                                                                Create
                                                            </Button>
                                                        }

                                                        {
                                                            ((props?.match?.params?.id && !blockState["workflow"] && blockState?.["createdByName"] === props?.members?.name) || (props?.match?.params?.id && blockState["workflow"] && blockState[toCamelCase(blockState?.status)]?.name === props?.members?.name)) && blockState?.["status"] !== "Rejected" && <Button
                                                                variant="contained"
                                                                className={classes.primaryBtnUpdate}
                                                                style={{ backgroundColor: 'red', color: 'white', border: 'none' }}
                                                                onClick={() => { onRejectObligation() }}
                                                            >
                                                                Reject This Document
                                                            </Button>
                                                        }

                                                        {
                                                            !blockState["workflow"] && props?.match?.params?.id && isEditMode && blockState?.["status"] !== "Rejected" && <Button
                                                                variant="contained"
                                                                className={classes.primaryBtn}
                                                                onClick={() => { handleSave() }}
                                                            >
                                                                Update
                                                            </Button>
                                                        }

                                                        {
                                                            blockState["workflow"] && props?.match?.params?.id && isEditMode && blockState[toCamelCase(blockState?.status)]?.name === props?.members?.name && blockState?.["status"] !== "Rejected" && <Button
                                                                variant="contained"
                                                                className={classes.primaryBtn}
                                                                onClick={() => { handleSave() }}
                                                            >
                                                                Update
                                                            </Button>
                                                        }

                                                        {/* {
                                            blockState["workflow"] && !props?.match?.params?.id && <Button
                                                variant="contained"
                                                className={classes.primaryBtn}
                                                onClick={() => { handleSave() }}
                                            >
                                                Create
                                            </Button>
                                        } */}
                                                        {/* {
                                            blockState["workflow"] && blockState[toCamelCase(blockState?.status)]?.name === props?.members?.name && <Button
                                                variant="contained"
                                                className={classes.primaryBtn}
                                                onClick={() => { handleSave() }}
                                            >
                                                {props?.match?.params?.id ? 'Update' : 'Create'}
                                            </Button>
                                        } */}

                                                        {
                                                            !blockState["workflow"] && props?.match?.params?.id && isWorkFlowEnable && blockState?.["status"] !== "Rejected" && blockState?.["createdByName"] === props?.members?.name && <Button
                                                                variant="contained"
                                                                className={isEditMode ? classes.primaryBtnUpdate : classes.primaryBtn}
                                                                onClick={() => { onModelClick('assignTo', {}) }}
                                                            >
                                                                {`Move to ${workflow?.length > 0 ? workflow[0]?.label : ''}`}
                                                            </Button>
                                                        }
                                                        {enableRejectButton && blockState[toCamelCase(blockState?.status)]?.name === props?.members?.name && blockState?.["status"] !== "Rejected" &&
                                                            blockState?.workflow?.type !== 'start' &&
                                                            blockState?.workflow?.type !== 'end' ? (
                                                            <Button className={isEditMode ? classes.primaryBtnUpdate : classes.primaryBtn} style={{ backgroundColor: 'red', color: 'white', border: 'none' }} onClick={() => { handleReject() }}>
                                                                Reject
                                                            </Button>
                                                        ) : null}
                                                        {
                                                            isWorkFlowEnable && blockState?.["status"] !== "Rejected" &&
                                                            blockState["workflow"] &&
                                                            blockState[toCamelCase(blockState?.status)]?.name === props?.members?.name &&
                                                            Boolean(Object.keys(nextStep || {}).length) &&
                                                            Array.isArray(nextStep?.currentPossibleAction) &&
                                                            nextStep?.currentPossibleAction.map((cpa, cpaIdx) => {
                                                                return (<Button
                                                                    className={isEditMode ? classes.primaryBtnUpdate : classes.primaryBtn}
                                                                    onClick={() => onModelClickForNextRespondent('assignTo', cpa)}
                                                                >
                                                                    {`Move to ${cpa?.label}`}
                                                                </Button>)
                                                            })
                                                        }
                                                    </div>

                                                )}
                                            </div>

                                        </React.Fragment>
                                    )
                            }
                        </React.Fragment>
                    )

            }


            {modalInfo?.enable && (
                <WorkFlowModelViewer
                    {...props}
                    modalInfo={modalInfo}
                    onCloseModel={onCloseModel}
                    onNoLater={onNoLater}
                    onJustSaveClick={onJustSaveClick}
                    defaultOptionsDropdown={defaultOptionsDropdown}
                    onAssignToFirstStepMembers={onAssignToFirstStepMembers}
                    onSaveMembersToFirstStep={onSaveMembersToFirstStep}
                    onAssignToParent={onAssignToParent}
                    onAssignTo={onAssignTo}
                    onSucessClick={onSucessClick}
                    onRejectedModel={onRejectedModel}
                    onSucessNextRespondentClick={onSucessNextRespondentClick}
                    onRejectedNextRespondentClick={onRejectedNextRespondentClick}
                />
            )}

        </div>
    );
}

export default HorizontalLinearStepper
